import React, { Component } from "react";
import { Tooltip, Tabs, Slider } from "materialize-css";
import MetaDecorator from "../../services/MetaDecorator";
import websites from "../../../media/images/fWebsites.jpg";
import websitesMobile from "../../../media/images/fWebsitesMobile.jpg";

class Websites extends Component {
  constructor(props) {
    super(props);
    this.sliderRef = React.createRef();
    this.tooltipRef = React.createRef();
    this.tabsRef = React.createRef();
    this.navTabsRef = React.createRef();
    this.state = {
      width: window.innerWidth,
    };
  }
  componentDidMount = () => {
    let tabs = document.getElementsByClassName("nav-wrapper");
    if (tabs.length > 0) {
      tabs = tabs[1].querySelectorAll("ul")[0].querySelectorAll("a");
      for (let i = 0; i < tabs.length; i++) {
        tabs[i].removeAttribute("class");
        if (tabs[i].id === "scopes" || tabs[i].id === "websites") {
          tabs[i].setAttribute("class", "orange-text text-darken-4");
        }
      }
    }
    let mobileTabs = document.getElementsByClassName("sidenav");
    if (mobileTabs.length > 0) {
      mobileTabs = mobileTabs[0].querySelectorAll("a");
      for (let i = 0; i < mobileTabs.length; i++) {
        if (
          mobileTabs[i].id === "scopesMobile" ||
          mobileTabs[i].id === "websitesMobile"
        ) {
          mobileTabs[i].removeAttribute("class");
          mobileTabs[i].setAttribute(
            "class",
            "orange-text text-darken-4 grey darken-3"
          );
        }
      }
    }

    Slider.init(this.sliderRef.current);

    var elems = document.querySelectorAll(".tooltipped");
    Tooltip.init(elems);

    this.updateWindowDimensions();
    window.addEventListener("resize", this.updateWindowDimensions.bind(this));
  };

  componentDidUpdate() {
    var elems = document.querySelectorAll(".tooltipped");
    Tooltip.init(elems);

    Tabs.init(this.tabsRef.current);
  }

  updateWindowDimensions = () => {
    this.setState({ width: window.innerWidth });
  };

  render() {
    const { width } = this.state;
    const isMobile = width <= 600;
    const isTablet = width <= 992 && width > 600;
    const isNotTabPro = width <= 1080;
    return (
      <React.Fragment>
        <MetaDecorator
          title="JetMinds | Hochwertige und moderne Webseiten für Ihren Webauftritt"
          descrption="Responsives und modernes Webdesign mit benutzerfreundlicher UX/UI. Wir bieten Ihnen leistungsstarke Webseiten, Webentwicklung, SEO, Analytics und CMS. Ihre Webagentur"
          url="https://www.jetminds.de/fokusbereiche/webseiten/"
        />
        <div className="pageImageTitle">
          {isMobile ? (
            <img
              className="responsive-img"
              style={{ width: "100%" }}
              src={websitesMobile}
              alt="JetMinds Webseiten"
              loading="lazy"
            />
          ) : (
            <img
              className="responsive-img"
              style={{ width: "100%" }}
              src={websites}
              alt="JetMinds Webseiten"
              loading="lazy"
            />
          )}
          {isMobile || isTablet ? (
            <div className="imgTxtMobile">
              <h1
                className={`white-text ${isTablet ? "isTablet" : "isMobile"}`}
              >
                Webdesign
              </h1>
              <a
                href="/insights"
                className="btn-large orange darken-4"
                style={{ margin: "20px" }}
              >
                Beispiele ansehen
              </a>
            </div>
          ) : (
            <div className="imgTxt">
              <h1 className="white-text">Webdesign</h1>
              <a
                href="/insights"
                className="btn-large orange darken-4"
                style={{ margin: "20px" }}
              >
                Beispiele ansehen
              </a>
            </div>
          )}
        </div>
        <div className="container">
          <div className="section">
            <div className="row">
              <div className="col s12 m12">
                <h1 className={`${isMobile ? "pageTitleM" : "pageTitle"}`}>
                  Moderne, responsive und{" "}
                  <span className="orange-text text-darken-4">performante</span>{" "}
                  Websites für die digitale Präsenz Ihrer{" "}
                  <span className="orange-text text-darken-4">
                    Unternehmenskommunikation
                  </span>
                </h1>
              </div>
            </div>
            <div className="row">
              <div className="col s12 m12">
                <p className="light">
                  In der digitalen Welt ist eine Website heute für jedes
                  Unternehmen von entscheidender Bedeutung. Wenn Ihr Unternehmen
                  keine Website hat, verlieren Sie wahrscheinlich viele Chancen
                  potentielle Kunden auf Ihre Firma aufmerksam zu machen. Auf
                  der anderen Seite, durch eine zeitgemäße und performante
                  Website können viele verschiedene Marketingstrategien
                  umgesetzt und Produkte, Leistungen und vieles mehr bekannt
                  gemacht werden um Ihr Unternehmen wachsen zu lassen.
                </p>
                <p className="light">
                  Eine Website hat eine weitaus größere Reichweite als jede
                  andere Form des konventionellen Marketings. Sie ist eines der
                  wichtigsten Kommunikationsmittel Ihres Unternehmens, das Sie
                  repräsentiert und vermittelt den Besuchern den ersten und
                  wertvollsten Eindruck von Ihren Dienstleistungen, Ihrem Stil
                  und Ihrer Kompetenz. Zusammengefasst, die Website ist Ihr
                  Online-Repräsentant an 365 Tagen rund um die Uhr.
                </p>
                <p className="light">
                  Wir unterstützen Sie bei der Erstellung Ihrer modernen,
                  responsiven und leistungsstarken Website. Selbstverständlich
                  erstellen wir auf Wunsch eine maßgeschneiderte Website für
                  Ihre spezifischen Anforderungen. Unsere unten gelisteten
                  Paket-Lösungen mit besonderen Services sind für kleine und
                  mittelständische Unternehmen bestens geeignet:
                </p>
              </div>
            </div>
            <div className="row">
              <div className={`col s12 ${isTablet ? "m12" : "m4"}`}>
                <div className="icon-block">
                  <h2 className="center orange-text text-darken-4">
                    <i className="material-icons" style={{ fontSize: "35px" }}>
                      euro_symbol
                    </i>
                  </h2>
                  <h5 className="center">Festpreis</h5>
                  <p className="light ">
                    Es fallen garantiert keine zusätzlichen Kosten an. Wir
                    bieten Ihnen eine 100%ig leistungsstarke Webseite mit bester
                    UX und UI zum unschlagbaren Festpreis.
                  </p>
                </div>
              </div>
              <div className={`col s12 ${isTablet ? "m12" : "m4"}`}>
                <div className="icon-block">
                  <h2 className="center orange-text text-darken-4">
                    <i className="material-icons" style={{ fontSize: "35px" }}>
                      favorite
                    </i>
                  </h2>
                  <h5 className="center">Passion</h5>
                  <p className="light">
                    Unser Lebenselixier ist die IT, in der wir uns zu Hause
                    fühlen. Jeden Tag genießen wir die modernen Technologien und
                    halten uns immer auf dem Laufenden.
                  </p>
                </div>
              </div>
              <div className={`col s12 ${isTablet ? "m12" : "m4"}`}>
                <div className="icon-block">
                  <h2 className="center orange-text text-darken-4">
                    <i className="material-icons" style={{ fontSize: "35px" }}>
                      fingerprint
                    </i>
                  </h2>
                  <h5 className="center">Tailor-Made</h5>
                  <p className="light">
                    {" "}
                    Wir machen für Sie eine maßgefertigte Website. Keine
                    "One-Click" Templates. Wir sind echte IT-ler und Fachleute,
                    die das Programmieren beherrschen.
                  </p>
                </div>
              </div>
            </div>
            <div className="row">
              <div className={`col s12 ${isTablet ? "m12" : "m4"}`}>
                <div className="icon-block">
                  <h2 className="center orange-text text-darken-4">
                    <i className="material-icons" style={{ fontSize: "35px" }}>
                      phonelink
                    </i>
                  </h2>
                  <h5 className="center">Responsive</h5>
                  <p className="light">
                    Ein modernes, responsives Webdesign, dass die Displays von
                    Laptops, PCs, Tablets, Smartphones und unterschiedlichen
                    Monitoren berücksichtigt.
                  </p>
                </div>
              </div>
              <div className={`col s12 ${isTablet ? "m12" : "m4"}`}>
                <div className="icon-block">
                  <h2 className="center orange-text text-darken-4">
                    <i className="material-icons" style={{ fontSize: "35px" }}>
                      flight_takeoff
                    </i>
                  </h2>
                  <h5 className="center">Go-Live</h5>
                  <p className="light">
                    In kürzester Zeit erstellen wir Ihre Website und realisieren
                    Ihre persönlichen Wünsche und haben dabei immer eine hohe
                    Qualität im Fokus.
                  </p>
                </div>
              </div>
              <div className={`col s12 ${isTablet ? "m12" : "m4"}`}>
                <div className="icon-block">
                  <h2 className="center orange-text text-darken-4">
                    <i className="material-icons" style={{ fontSize: "35px" }}>
                      network_check
                    </i>
                  </h2>
                  <h5 className="center">Performance</h5>
                  <p className="light">
                    Wir heben uns durch performante Seiten ab, keine Kosten für
                    Ladungs-, bzw. Performanceoptimierung. Von Anfang an liegt
                    Ihnen eine hochwertige Website vor.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="section">
            <div className="row">
              <div className="col s12">
                <ul className="tabs website" ref={this.tabsRef}>
                  <li className="tab col m3">
                    <a className="active" href="#starter">
                      Starter
                    </a>
                  </li>
                  <li className="tab col m3">
                    <a href="#premium">Premium</a>
                  </li>
                  <li className="tab col m3">
                    <a href="#cms">CMS</a>
                  </li>
                  <li className="tab col m3">
                    <a href="#cmsPremium">CMS Premium</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          {isNotTabPro ? (
            <div className="section">
              <div className="row">
                <div className="col s12">
                  <h4>Pakete</h4>
                </div>
              </div>
              <div id="starter">
                <div className="row">
                  <div className="col s12">
                    <div className="card hoverable blue lighten-1">
                      <div className="card-content black-text">
                        <table className="centered">
                          <thead>
                            <tr>
                              <th style={{ fontSize: "18px", color: "black" }}>
                                Essential
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>1 Seite</td>
                            </tr>
                            <tr>
                              <td>Maßgefertigter Designentwurf</td>
                            </tr>
                            <tr>
                              <td>HTML5 Template</td>
                            </tr>
                            <tr>
                              <td>Datenschutz</td>
                            </tr>
                            <tr>
                              <td>
                                + 339,– € * für Responsivedesign{" "}
                                <i
                                  className="tooltipped material-icons right"
                                  data-position="left"
                                  data-tooltip="Responsive für Endgeräte, vor allem Smartphones und Tablets"
                                  style={{ fontSize: "18px" }}
                                >
                                  info_outline
                                </i>
                              </td>
                            </tr>
                            <tr>
                              <td>-</td>
                            </tr>
                            <tr>
                              <td>-</td>
                            </tr>
                            <tr>
                              <td>-</td>
                            </tr>
                            <tr>
                              <td>-</td>
                            </tr>
                            <tr>
                              <td>-</td>
                            </tr>
                            <tr>
                              <td>-</td>
                            </tr>
                            <tr>
                              <td>-</td>
                            </tr>
                            <tr>
                              <td>-</td>
                            </tr>
                            <tr>
                              <td>
                                <b>719,– € * </b>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                  <div className="col s12">
                    <div className="card hoverable orange darken-1">
                      <div className="card-content black-text">
                        <table className="centered">
                          <thead>
                            <tr>
                              <th style={{ fontSize: "18px", color: "black" }}>
                                Business
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>3 Seiten</td>
                            </tr>
                            <tr>
                              <td>Maßgefertigter Designentwurf</td>
                            </tr>
                            <tr>
                              <td>HTML5 Template</td>
                            </tr>
                            <tr>
                              <td>Datenschutz</td>
                            </tr>
                            <tr>
                              <td>
                                + 580,– € * für Responsivedesign{" "}
                                <i
                                  className="tooltipped material-icons right"
                                  data-position="left"
                                  data-tooltip="Responsive für Endgeräte, vor allem Smartphones und Tablets"
                                  style={{ fontSize: "18px" }}
                                >
                                  info_outline
                                </i>
                              </td>
                            </tr>
                            <tr>
                              <td>-</td>
                            </tr>
                            <tr>
                              <td>-</td>
                            </tr>
                            <tr>
                              <td>-</td>
                            </tr>
                            <tr>
                              <td>-</td>
                            </tr>
                            <tr>
                              <td>-</td>
                            </tr>
                            <tr>
                              <td>-</td>
                            </tr>
                            <tr>
                              <td>-</td>
                            </tr>
                            <tr>
                              <td>-</td>
                            </tr>
                            <tr>
                              <td>
                                <b>1.785,– € *</b>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                  <div className="col s12">
                    <div className="card hoverable orange darken-4">
                      <div className="card-content black-text">
                        <table className="centered">
                          <thead>
                            <tr>
                              <th style={{ fontSize: "18px", color: "black" }}>
                                Pro
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>6 Seiten</td>
                            </tr>
                            <tr>
                              <td>Maßgefertigter Designentwurf</td>
                            </tr>
                            <tr>
                              <td>HTML5 Template</td>
                            </tr>
                            <tr>
                              <td>Datenschutz</td>
                            </tr>
                            <tr>
                              <td>
                                + 999,– € * für Responsivedesign{" "}
                                <i
                                  className="tooltipped material-icons right"
                                  data-position="left"
                                  data-tooltip="Responsive für Endgeräte, vor allem Smartphones und Tablets"
                                  style={{ fontSize: "18px" }}
                                >
                                  info_outline
                                </i>
                              </td>
                            </tr>
                            <tr>
                              <td>Social Media Links</td>
                            </tr>
                            <tr>
                              <td>Kontaktformular</td>
                            </tr>
                            <tr>
                              <td>-</td>
                            </tr>
                            <tr>
                              <td>-</td>
                            </tr>
                            <tr>
                              <td>-</td>
                            </tr>
                            <tr>
                              <td>-</td>
                            </tr>
                            <tr>
                              <td>-</td>
                            </tr>
                            <tr>
                              <td>-</td>
                            </tr>
                            <tr>
                              <td>
                                <b>2.975,– € *</b>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col s12">
                    <h4>Webhosting</h4>
                  </div>
                </div>
                <div className="row">
                  <div className="col s12">
                    <div className="card hoverable blue lighten-1">
                      <div className="card-content black-text">
                        <table className="centered">
                          <thead>
                            <tr>
                              <th style={{ fontSize: "18px", color: "black" }}>
                                Essential
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>
                                1 Domäne inklusive{" "}
                                <i
                                  className="tooltipped material-icons right"
                                  data-position="left"
                                  data-tooltip="Sie bekommen eine kostenlose Domäne: .de, .eu, .com, .net, .org, .info, .me, .biz, .online"
                                  style={{ fontSize: "18px" }}
                                >
                                  info_outline
                                </i>
                              </td>
                            </tr>
                            <tr>
                              <td>50 GB Webspace</td>
                            </tr>
                            <tr>
                              <td>
                                5 SSD Datenbanken
                                <i
                                  className="tooltipped material-icons right"
                                  data-position="left"
                                  data-tooltip="Je Datenbank 1 GB"
                                  style={{ fontSize: "18px" }}
                                >
                                  info_outline
                                </i>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                10 E-Mail-Postfächer
                                <i
                                  className="tooltipped material-icons right"
                                  data-position="left"
                                  data-tooltip="Je Postfach 2 GB (für ca. 10.000 Emails) jederzeit erweiterbar"
                                  style={{ fontSize: "18px" }}
                                >
                                  info_outline
                                </i>
                              </td>
                            </tr>
                            <tr>
                              <td>Spam-Filter</td>
                            </tr>
                            <tr>
                              <td>SSL</td>
                            </tr>
                            <tr>
                              <td>89,– € * Einmalige Einrichtungsgebühr</td>
                            </tr>
                            <tr>
                              <td>49,– € / mtl. * Wartungsservice </td>
                            </tr>
                            <tr>
                              <td>
                                <b>4,– € / mtl.</b>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                  <div className="col s12">
                    <div className="card hoverable orange darken-1">
                      <div className="card-content black-text">
                        <table className="centered">
                          <thead>
                            <tr>
                              <th style={{ fontSize: "18px", color: "black" }}>
                                Business
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>
                                1 Domäne inklusive{" "}
                                <i
                                  className="tooltipped material-icons right"
                                  data-position="left"
                                  data-tooltip="Sie bekommen eine kostenlose Domäne: .de, .eu, .com, .net, .org, .info, .me, .biz, .online"
                                  style={{ fontSize: "18px" }}
                                >
                                  info_outline
                                </i>
                              </td>
                            </tr>
                            <tr>
                              <td>50 GB Webspace</td>
                            </tr>
                            <tr>
                              <td>
                                5 SSD Datenbanken
                                <i
                                  className="tooltipped material-icons right"
                                  data-position="left"
                                  data-tooltip="Je Datenbank 1 GB"
                                  style={{ fontSize: "18px" }}
                                >
                                  info_outline
                                </i>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                10 E-Mail-Postfächer
                                <i
                                  className="tooltipped material-icons right"
                                  data-position="left"
                                  data-tooltip="Je Postfach 2 GB (für ca. 10.000 Emails) jederzeit erweiterbar"
                                  style={{ fontSize: "18px" }}
                                >
                                  info_outline
                                </i>
                              </td>
                            </tr>
                            <tr>
                              <td>Spam-Filter</td>
                            </tr>
                            <tr>
                              <td>SSL</td>
                            </tr>
                            <tr>
                              <td>89,– € * Einmalige Einrichtungsgebühr</td>
                            </tr>
                            <tr>
                              <td>49,– € / mtl. * Wartungsservice </td>
                            </tr>
                            <tr>
                              <td>
                                <b>4,– € / mtl.</b>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                  <div className="col s12">
                    <div className="card hoverable orange darken-4">
                      <div className="card-content black-text">
                        <table className="centered">
                          <thead>
                            <tr>
                              <th style={{ fontSize: "18px", color: "black" }}>
                                Pro
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>
                                1 Domäne inklusive{" "}
                                <i
                                  className="tooltipped material-icons right"
                                  data-position="left"
                                  data-tooltip="Sie bekommen eine kostenlose Domäne: .de, .eu, .com, .net, .org, .info, .me, .biz, .online"
                                  style={{ fontSize: "18px" }}
                                >
                                  info_outline
                                </i>
                              </td>
                            </tr>
                            <tr>
                              <td>50 GB Webspace</td>
                            </tr>
                            <tr>
                              <td>
                                5 SSD Datenbanken
                                <i
                                  className="tooltipped material-icons right"
                                  data-position="left"
                                  data-tooltip="Je Datenbank 1 GB"
                                  style={{ fontSize: "18px" }}
                                >
                                  info_outline
                                </i>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                10 E-Mail-Postfächer
                                <i
                                  className="tooltipped material-icons right"
                                  data-position="left"
                                  data-tooltip="Je Postfach 2 GB (für ca. 10.000 Emails) jederzeit erweiterbar"
                                  style={{ fontSize: "18px" }}
                                >
                                  info_outline
                                </i>
                              </td>
                            </tr>
                            <tr>
                              <td>Spam-Filter</td>
                            </tr>
                            <tr>
                              <td>SSL</td>
                            </tr>
                            <tr>
                              <td>89,– € * Einmalige Einrichtungsgebühr</td>
                            </tr>
                            <tr>
                              <td>49,– € / mtl. * Wartungsservice </td>
                            </tr>
                            <tr>
                              <td>
                                <b>4,– € / mtl.</b>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div id="premium">
                <div className="row">
                  <div className="col s12">
                    <div className="card hoverable blue lighten-1">
                      <div className="card-content black-text">
                        <table className="centered">
                          <thead>
                            <tr>
                              <th style={{ fontSize: "18px", color: "black" }}>
                                Pro + 3
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>9 Seiten</td>
                            </tr>
                            <tr>
                              <td>Maßgefertigter Designentwurf</td>
                            </tr>
                            <tr>
                              <td>HTML5 Template</td>
                            </tr>
                            <tr>
                              <td>Datenschutz</td>
                            </tr>
                            <tr>
                              <td>
                                + 1.299,– € * für Responsivedesign
                                <i
                                  className="tooltipped material-icons right"
                                  data-position="left"
                                  data-tooltip="Responsive für Endgeräte, vor allem Smartphones und Tablets"
                                  style={{ fontSize: "18px" }}
                                >
                                  info_outline
                                </i>
                              </td>
                            </tr>
                            <tr>
                              <td>-</td>
                            </tr>
                            <tr>
                              <td>-</td>
                            </tr>
                            <tr>
                              <td>-</td>
                            </tr>
                            <tr>
                              <td>-</td>
                            </tr>
                            <tr>
                              <td>-</td>
                            </tr>
                            <tr>
                              <td>-</td>
                            </tr>
                            <tr>
                              <td>-</td>
                            </tr>
                            <tr>
                              <td>-</td>
                            </tr>
                            <tr>
                              <td>
                                <b>4.289,– € *</b>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                  <div className="col s12">
                    <div className="card hoverable orange darken-1">
                      <div className="card-content black-text">
                        <table className="centered">
                          <thead>
                            <tr>
                              <th style={{ fontSize: "18px", color: "black" }}>
                                Pro + 6
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>12 Seiten</td>
                            </tr>
                            <tr>
                              <td>Maßgefertigter Designentwurf</td>
                            </tr>
                            <tr>
                              <td>HTML5 Template</td>
                            </tr>
                            <tr>
                              <td>Datenschutz</td>
                            </tr>
                            <tr>
                              <td>
                                + 1.779,– € * für Responsivedesign
                                <i
                                  className="tooltipped material-icons right"
                                  data-position="left"
                                  data-tooltip="Responsive für Endgeräte, vor allem Smartphones und Tablets"
                                  style={{ fontSize: "18px" }}
                                >
                                  info_outline
                                </i>
                              </td>
                            </tr>
                            <tr>
                              <td>-</td>
                            </tr>
                            <tr>
                              <td>-</td>
                            </tr>
                            <tr>
                              <td>-</td>
                            </tr>
                            <tr>
                              <td>-</td>
                            </tr>
                            <tr>
                              <td>-</td>
                            </tr>
                            <tr>
                              <td>-</td>
                            </tr>
                            <tr>
                              <td>-</td>
                            </tr>
                            <tr>
                              <td>-</td>
                            </tr>
                            <tr>
                              <td>
                                <b>5.750,– € *</b>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                  <div className="col s12">
                    <div className="card hoverable orange darken-4">
                      <div className="card-content black-text">
                        <table className="centered">
                          <thead>
                            <tr>
                              <th style={{ fontSize: "18px", color: "black" }}>
                                Pro + 12
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>18 Seiten</td>
                            </tr>
                            <tr>
                              <td>Maßgefertigter Designentwurf</td>
                            </tr>
                            <tr>
                              <td>HTML5 Template</td>
                            </tr>
                            <tr>
                              <td>Datenschutz</td>
                            </tr>
                            <tr>
                              <td>
                                + 2.579,– € * für Responsivedesign{" "}
                                <i
                                  className="tooltipped material-icons right"
                                  data-position="left"
                                  data-tooltip="Responsive für Endgeräte, vor allem Smartphones und Tablets"
                                  style={{ fontSize: "18px" }}
                                >
                                  info_outline
                                </i>
                              </td>
                            </tr>
                            <tr>
                              <td>Social Media Links</td>
                            </tr>
                            <tr>
                              <td>Kontaktformular</td>
                            </tr>
                            <tr>
                              <td>-</td>
                            </tr>
                            <tr>
                              <td>-</td>
                            </tr>
                            <tr>
                              <td>-</td>
                            </tr>
                            <tr>
                              <td>-</td>
                            </tr>
                            <tr>
                              <td>-</td>
                            </tr>
                            <tr>
                              <td>-</td>
                            </tr>
                            <tr>
                              <td>
                                <b>8.589,– € *</b>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col s12">
                    <h4>Webhosting</h4>
                  </div>
                </div>
                <div className="row">
                  <div className="col s12">
                    <div className="card hoverable blue lighten-1">
                      <div className="card-content black-text">
                        <table className="centered">
                          <thead>
                            <tr>
                              <th style={{ fontSize: "18px", color: "black" }}>
                                Pro + 3
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>
                                1 Domäne inklusive{" "}
                                <i
                                  className="tooltipped material-icons right"
                                  data-position="left"
                                  data-tooltip="Sie bekommen eine kostenlose Domäne: .de, .eu, .com, .net, .org, .info, .me, .biz, .online"
                                  style={{ fontSize: "18px" }}
                                >
                                  info_outline
                                </i>
                              </td>
                            </tr>
                            <tr>
                              <td>50 GB Webspace</td>
                            </tr>
                            <tr>
                              <td>
                                5 SSD Datenbanken
                                <i
                                  className="tooltipped material-icons right"
                                  data-position="left"
                                  data-tooltip="Je Datenbank 1 GB"
                                  style={{ fontSize: "18px" }}
                                >
                                  info_outline
                                </i>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                10 E-Mail-Postfächer
                                <i
                                  className="tooltipped material-icons right"
                                  data-position="left"
                                  data-tooltip="Je Postfach 2 GB (für ca. 10.000 Emails) jederzeit erweiterbar"
                                  style={{ fontSize: "18px" }}
                                >
                                  info_outline
                                </i>
                              </td>
                            </tr>
                            <tr>
                              <td>Spam-Filter</td>
                            </tr>
                            <tr>
                              <td>SSL</td>
                            </tr>
                            <tr>
                              <td>89,– € * Einmalige Einrichtungsgebühr</td>
                            </tr>
                            <tr>
                              <td>49,– € / mtl. * Wartungsservice </td>
                            </tr>
                            <tr>
                              <td>
                                <b>4,– € / mtl.</b>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                  <div className="col s12">
                    <div className="card hoverable orange darken-1">
                      <div className="card-content black-text">
                        <table className="centered">
                          <thead>
                            <tr>
                              <th style={{ fontSize: "18px", color: "black" }}>
                                Pro + 6
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>
                                1 Domäne inklusive{" "}
                                <i
                                  className="tooltipped material-icons right"
                                  data-position="left"
                                  data-tooltip="Sie bekommen eine kostenlose Domäne: .de, .eu, .com, .net, .org, .info, .me, .biz, .online"
                                  style={{ fontSize: "18px" }}
                                >
                                  info_outline
                                </i>
                              </td>
                            </tr>
                            <tr>
                              <td>50 GB Webspace</td>
                            </tr>
                            <tr>
                              <td>
                                5 SSD Datenbanken
                                <i
                                  className="tooltipped material-icons right"
                                  data-position="left"
                                  data-tooltip="Je Datenbank 1 GB"
                                  style={{ fontSize: "18px" }}
                                >
                                  info_outline
                                </i>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                10 E-Mail-Postfächer
                                <i
                                  className="tooltipped material-icons right"
                                  data-position="left"
                                  data-tooltip="Je Postfach 2 GB (für ca. 10.000 Emails) jederzeit erweiterbar"
                                  style={{ fontSize: "18px" }}
                                >
                                  info_outline
                                </i>
                              </td>
                            </tr>
                            <tr>
                              <td>Spam-Filter</td>
                            </tr>
                            <tr>
                              <td>SSL</td>
                            </tr>
                            <tr>
                              <td>89,– € * Einmalige Einrichtungsgebühr</td>
                            </tr>
                            <tr>
                              <td>49,– € / mtl. * Wartungsservice </td>
                            </tr>
                            <tr>
                              <td>
                                <b>4,– € / mtl.</b>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                  <div className="col s12">
                    <div className="card hoverable orange darken-4">
                      <div className="card-content black-text">
                        <table className="centered">
                          <thead>
                            <tr>
                              <th style={{ fontSize: "18px", color: "black" }}>
                                Pro + 12
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>
                                1 Domäne inklusive{" "}
                                <i
                                  className="tooltipped material-icons right"
                                  data-position="left"
                                  data-tooltip="Sie bekommen eine kostenlose Domäne: .de, .eu, .com, .net, .org, .info, .me, .biz, .online"
                                  style={{ fontSize: "18px" }}
                                >
                                  info_outline
                                </i>
                              </td>
                            </tr>
                            <tr>
                              <td>50 GB Webspace</td>
                            </tr>
                            <tr>
                              <td>
                                5 SSD Datenbanken
                                <i
                                  className="tooltipped material-icons right"
                                  data-position="left"
                                  data-tooltip="Je Datenbank 1 GB"
                                  style={{ fontSize: "18px" }}
                                >
                                  info_outline
                                </i>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                10 E-Mail-Postfächer
                                <i
                                  className="tooltipped material-icons right"
                                  data-position="left"
                                  data-tooltip="Je Postfach 2 GB (für ca. 10.000 Emails) jederzeit erweiterbar"
                                  style={{ fontSize: "18px" }}
                                >
                                  info_outline
                                </i>
                              </td>
                            </tr>
                            <tr>
                              <td>Spam-Filter</td>
                            </tr>
                            <tr>
                              <td>SSL</td>
                            </tr>
                            <tr>
                              <td>89,– € * Einmalige Einrichtungsgebühr</td>
                            </tr>
                            <tr>
                              <td>49,– € / mtl. * Wartungsservice </td>
                            </tr>
                            <tr>
                              <td>
                                <b>4,– € / mtl.</b>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div id="cms">
                <div className="row">
                  <div className="col s12">
                    <div className="card hoverable blue lighten-1">
                      <div className="card-content black-text">
                        <table className="centered">
                          <thead>
                            <tr>
                              <th style={{ fontSize: "18px", color: "black" }}>
                                Essential
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>9 Seiten</td>
                            </tr>
                            <tr>
                              <td>Maßgefertigter Designentwurf</td>
                            </tr>
                            <tr>
                              <td>HTML5 Template</td>
                            </tr>
                            <tr>
                              <td>Datenschutz</td>
                            </tr>
                            <tr>
                              <td>
                                + 1.299,– € * für Responsivedesign
                                <i
                                  className="tooltipped material-icons right"
                                  data-position="left"
                                  data-tooltip="Responsive für Endgeräte, vor allem Smartphones und Tablets"
                                  style={{ fontSize: "18px" }}
                                >
                                  info_outline
                                </i>
                              </td>
                            </tr>
                            <tr>
                              <td>-</td>
                            </tr>
                            <tr>
                              <td>-</td>
                            </tr>
                            <tr>
                              <td>-</td>
                            </tr>
                            <tr>
                              <td>-</td>
                            </tr>
                            <tr>
                              <td>-</td>
                            </tr>
                            <tr>
                              <td>-</td>
                            </tr>
                            <tr>
                              <td>-</td>
                            </tr>
                            <tr>
                              <td>-</td>
                            </tr>
                            <tr>
                              <td>
                                <b>6.388,– € *</b>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                  <div className="col s12">
                    <div className="card hoverable orange darken-1">
                      <div className="card-content black-text">
                        <table className="centered">
                          <thead>
                            <tr>
                              <th style={{ fontSize: "18px", color: "black" }}>
                                Business
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>12 Seiten</td>
                            </tr>
                            <tr>
                              <td>Maßgefertigter Designentwurf</td>
                            </tr>
                            <tr>
                              <td>HTML5 Template</td>
                            </tr>
                            <tr>
                              <td>Datenschutz</td>
                            </tr>
                            <tr>
                              <td>
                                + 1.779,– € * für Responsivedesign
                                <i
                                  className="tooltipped material-icons right"
                                  data-position="left"
                                  data-tooltip="Responsive für Endgeräte, vor allem Smartphones und Tablets"
                                  style={{ fontSize: "18px" }}
                                >
                                  info_outline
                                </i>
                              </td>
                            </tr>
                            <tr>
                              <td>-</td>
                            </tr>
                            <tr>
                              <td>-</td>
                            </tr>
                            <tr>
                              <td>-</td>
                            </tr>
                            <tr>
                              <td>-</td>
                            </tr>
                            <tr>
                              <td>-</td>
                            </tr>
                            <tr>
                              <td>-</td>
                            </tr>
                            <tr>
                              <td>-</td>
                            </tr>
                            <tr>
                              <td>-</td>
                            </tr>
                            <tr>
                              <td>
                                <b>7.849,– € *</b>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                  <div className="col s12">
                    <div className="card hoverable orange darken-4">
                      <div className="card-content black-text">
                        <table className="centered">
                          <thead>
                            <tr>
                              <th style={{ fontSize: "18px", color: "black" }}>
                                Pro
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>18 Seiten</td>
                            </tr>
                            <tr>
                              <td>Maßgefertigter Designentwurf</td>
                            </tr>
                            <tr>
                              <td>HTML5 Template</td>
                            </tr>
                            <tr>
                              <td>Datenschutz</td>
                            </tr>
                            <tr>
                              <td>
                                + 2.579,– € * für Responsivedesign{" "}
                                <i
                                  className="tooltipped material-icons right"
                                  data-position="left"
                                  data-tooltip="Responsive für Endgeräte, vor allem Smartphones und Tablets"
                                  style={{ fontSize: "18px" }}
                                >
                                  info_outline
                                </i>
                              </td>
                            </tr>
                            <tr>
                              <td>Social Media Links</td>
                            </tr>
                            <tr>
                              <td>Kontaktformular</td>
                            </tr>
                            <tr>
                              <td>-</td>
                            </tr>
                            <tr>
                              <td>-</td>
                            </tr>
                            <tr>
                              <td>-</td>
                            </tr>
                            <tr>
                              <td>-</td>
                            </tr>
                            <tr>
                              <td>-</td>
                            </tr>
                            <tr>
                              <td>-</td>
                            </tr>
                            <tr>
                              <td>
                                <b>10.688,– € *</b>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div id="cmsPremium">
                <div className="row">
                  <div className="col s12">
                    <div className="card hoverable blue lighten-1">
                      <div className="card-content black-text">
                        <table className="centered">
                          <thead>
                            <tr>
                              <th style={{ fontSize: "18px", color: "black" }}>
                                CMS + 6
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>24 Seiten</td>
                            </tr>
                            <tr>
                              <td>Maßgefertigter Designentwurf</td>
                            </tr>
                            <tr>
                              <td>HTML5 Template</td>
                            </tr>
                            <tr>
                              <td>Datenschutz</td>
                            </tr>
                            <tr>
                              <td>
                                + 3.475,– € * für Responsivedesign
                                <i
                                  className="tooltipped material-icons right"
                                  data-position="left"
                                  data-tooltip="Responsive für Endgeräte, vor allem Smartphones und Tablets"
                                  style={{ fontSize: "18px" }}
                                >
                                  info_outline
                                </i>
                              </td>
                            </tr>
                            <tr>
                              <td>-</td>
                            </tr>
                            <tr>
                              <td>-</td>
                            </tr>
                            <tr>
                              <td>-</td>
                            </tr>
                            <tr>
                              <td>-</td>
                            </tr>
                            <tr>
                              <td>-</td>
                            </tr>
                            <tr>
                              <td>-</td>
                            </tr>
                            <tr>
                              <td>-</td>
                            </tr>
                            <tr>
                              <td>-</td>
                            </tr>
                            <tr>
                              <td>
                                <b>14.369,– € *</b>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                  <div className="col s12">
                    <div className="card hoverable orange darken-1">
                      <div className="card-content black-text">
                        <table className="centered">
                          <thead>
                            <tr>
                              <th style={{ fontSize: "18px", color: "black" }}>
                                CMS + 12
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>30 Seiten</td>
                            </tr>
                            <tr>
                              <td>Maßgefertigter Designentwurf</td>
                            </tr>
                            <tr>
                              <td>HTML5 Template</td>
                            </tr>
                            <tr>
                              <td>Datenschutz</td>
                            </tr>
                            <tr>
                              <td>
                                + 5.254,– € * für Responsivedesign
                                <i
                                  className="tooltipped material-icons right"
                                  data-position="left"
                                  data-tooltip="Responsive für Endgeräte, vor allem Smartphones und Tablets"
                                  style={{ fontSize: "18px" }}
                                >
                                  info_outline
                                </i>
                              </td>
                            </tr>
                            <tr>
                              <td>-</td>
                            </tr>
                            <tr>
                              <td>-</td>
                            </tr>
                            <tr>
                              <td>-</td>
                            </tr>
                            <tr>
                              <td>-</td>
                            </tr>
                            <tr>
                              <td>-</td>
                            </tr>
                            <tr>
                              <td>-</td>
                            </tr>
                            <tr>
                              <td>-</td>
                            </tr>
                            <tr>
                              <td>-</td>
                            </tr>
                            <tr>
                              <td>
                                <b>17.789,– € *</b>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                  <div className="col s12">
                    <div className="card hoverable orange darken-4">
                      <div className="card-content black-text">
                        <table className="centered">
                          <thead>
                            <tr>
                              <th style={{ fontSize: "18px", color: "black" }}>
                                CMS + 18
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>36 Seiten</td>
                            </tr>
                            <tr>
                              <td>Maßgefertigter Designentwurf</td>
                            </tr>
                            <tr>
                              <td>HTML5 Template</td>
                            </tr>
                            <tr>
                              <td>Datenschutz</td>
                            </tr>
                            <tr>
                              <td>
                                + 6.889,– € * für Responsivedesign{" "}
                                <i
                                  className="tooltipped material-icons right"
                                  data-position="left"
                                  data-tooltip="Responsive für Endgeräte, vor allem Smartphones und Tablets"
                                  style={{ fontSize: "18px" }}
                                >
                                  info_outline
                                </i>
                              </td>
                            </tr>
                            <tr>
                              <td>Social Media Links</td>
                            </tr>
                            <tr>
                              <td>Kontaktformular</td>
                            </tr>
                            <tr>
                              <td>-</td>
                            </tr>
                            <tr>
                              <td>-</td>
                            </tr>
                            <tr>
                              <td>-</td>
                            </tr>
                            <tr>
                              <td>-</td>
                            </tr>
                            <tr>
                              <td>-</td>
                            </tr>
                            <tr>
                              <td>-</td>
                            </tr>
                            <tr>
                              <td>
                                <b>21.759,– € *</b>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <div className="section">
              <div id="starter">
                <div className="row">
                  <div className="col s3">
                    <table style={{ marginTop: "32px" }}>
                      <thead>
                        <tr>
                          <th style={{ fontSize: "18px" }}>Paket</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>Seiten</td>
                        </tr>
                        <tr>
                          <td>
                            <span>Designentwurf</span>
                          </td>
                        </tr>
                        <tr>
                          <td>HTML5 Template</td>
                        </tr>
                        <tr>
                          <td>Datenschutz</td>
                        </tr>
                        <tr>
                          <td>
                            Responsive{" "}
                            <i
                              className="tooltipped material-icons right"
                              data-position="right"
                              data-tooltip="Responsive für Endgeräte, vor allem Smartphones und Tablets"
                              style={{ fontSize: "18px" }}
                            >
                              info_outline
                            </i>
                          </td>
                        </tr>
                        <tr>
                          <td>Social Media Links</td>
                        </tr>
                        <tr>
                          <td>Kontaktformular</td>
                        </tr>
                        <tr>
                          <td>Location Karte</td>
                        </tr>
                        <tr>
                          <td>SEO</td>
                        </tr>
                        <tr>
                          <td>Google Analytics</td>
                        </tr>
                        <tr>
                          <td>Tag Manager</td>
                        </tr>
                        <tr>
                          <td>Google Optimize</td>
                        </tr>
                        <tr>
                          <td>Multilingual</td>
                        </tr>
                        <tr>
                          <td>
                            <b>Preis</b>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div className="col s3">
                    <div className="card hoverable blue lighten-1">
                      <div className="card-content black-text">
                        <table className="centered">
                          <thead>
                            <tr>
                              <th style={{ fontSize: "18px", color: "black" }}>
                                Essential
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>1</td>
                            </tr>
                            <tr>
                              <td className="check">
                                <i className="material-icons">check_circle</i>
                              </td>
                            </tr>
                            <tr>
                              <td className="check">
                                <i className="material-icons">check_circle</i>
                              </td>
                            </tr>
                            <tr>
                              <td className="check">
                                <i className="material-icons">check_circle</i>
                              </td>
                            </tr>
                            <tr>
                              <td>+ 339,– € *</td>
                            </tr>
                            <tr>
                              <td>-</td>
                            </tr>
                            <tr>
                              <td>-</td>
                            </tr>
                            <tr>
                              <td>-</td>
                            </tr>
                            <tr>
                              <td>-</td>
                            </tr>
                            <tr>
                              <td>-</td>
                            </tr>
                            <tr>
                              <td>-</td>
                            </tr>
                            <tr>
                              <td>-</td>
                            </tr>
                            <tr>
                              <td>-</td>
                            </tr>
                            <tr>
                              <td>
                                <b>719,– € *</b>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                  <div className="col s3">
                    <div className="card hoverable orange darken-1">
                      <div className="card-content black-text">
                        <table className="centered">
                          <thead>
                            <tr>
                              <th style={{ fontSize: "18px", color: "black" }}>
                                Business
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>3</td>
                            </tr>
                            <tr>
                              <td className="check">
                                <i className="material-icons">check_circle</i>
                              </td>
                            </tr>
                            <tr>
                              <td className="check">
                                <i className="material-icons">check_circle</i>
                              </td>
                            </tr>
                            <tr>
                              <td className="check">
                                <i className="material-icons">check_circle</i>
                              </td>
                            </tr>
                            <tr>
                              <td>+ 580,– € *</td>
                            </tr>
                            <tr>
                              <td>-</td>
                            </tr>
                            <tr>
                              <td>-</td>
                            </tr>
                            <tr>
                              <td>-</td>
                            </tr>
                            <tr>
                              <td>-</td>
                            </tr>
                            <tr>
                              <td>-</td>
                            </tr>
                            <tr>
                              <td>-</td>
                            </tr>
                            <tr>
                              <td>-</td>
                            </tr>
                            <tr>
                              <td>-</td>
                            </tr>
                            <tr>
                              <td>
                                <b>1.785,– € *</b>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                  <div className="col s3">
                    <div className="card hoverable orange darken-4">
                      <div className="card-content black-text">
                        <table className="centered">
                          <thead>
                            <tr>
                              <th style={{ fontSize: "18px", color: "black" }}>
                                Pro
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>6</td>
                            </tr>
                            <tr>
                              <td className="check">
                                <i className="material-icons">check_circle</i>
                              </td>
                            </tr>
                            <tr>
                              <td className="check">
                                <i className="material-icons">check_circle</i>
                              </td>
                            </tr>
                            <tr>
                              <td className="check">
                                <i className="material-icons">check_circle</i>
                              </td>
                            </tr>
                            <tr>
                              <td>+ 999,– € *</td>
                            </tr>
                            <tr>
                              <td className="check">
                                <i className="material-icons">check_circle</i>
                              </td>
                            </tr>
                            <tr>
                              <td className="check">
                                <i className="material-icons">check_circle</i>
                              </td>
                            </tr>
                            <tr>
                              <td>-</td>
                            </tr>
                            <tr>
                              <td>-</td>
                            </tr>
                            <tr>
                              <td>-</td>
                            </tr>
                            <tr>
                              <td>-</td>
                            </tr>
                            <tr>
                              <td>-</td>
                            </tr>
                            <tr>
                              <td>-</td>
                            </tr>
                            <tr>
                              <td>
                                <b>2.975,– € *</b>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col s3">
                    <table style={{ marginTop: "32px" }}>
                      <thead>
                        <tr>
                          <th style={{ fontSize: "18px" }}>Webhosting</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>
                            Domäne inklusive{" "}
                            <i
                              className="tooltipped material-icons right"
                              data-position="left"
                              data-tooltip="Sie bekommen eine kostenlose Domäne: .de, .eu, .com, .net, .org, .info, .me, .biz, .online"
                              style={{ fontSize: "18px" }}
                            >
                              info_outline
                            </i>
                          </td>
                        </tr>
                        <tr>
                          <td>Webspace</td>
                        </tr>
                        <tr>
                          <td>
                            Datenbanken
                            <i
                              className="tooltipped material-icons right"
                              data-position="left"
                              data-tooltip="Je Datenbank 1 GB"
                              style={{ fontSize: "18px" }}
                            >
                              info_outline
                            </i>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            E-Mail-Postfächer
                            <i
                              className="tooltipped material-icons right"
                              data-position="left"
                              data-tooltip="Je Postfach 2 GB (für ca. 10.000 Emails) jederzeit erweiterbar"
                              style={{ fontSize: "18px" }}
                            >
                              info_outline
                            </i>
                          </td>
                        </tr>
                        <tr>
                          <td>Spam-Filter</td>
                        </tr>
                        <tr>
                          <td>SSL</td>
                        </tr>
                        <tr>
                          <td>
                            Einrichtungsgebühr
                            <i
                              className="tooltipped material-icons right"
                              data-position="left"
                              data-tooltip="Einmalige Einrichtungsgebühr"
                              style={{ fontSize: "18px" }}
                            >
                              info_outline
                            </i>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            Wartungsservice / mtl.
                            <i
                              className="tooltipped material-icons right"
                              data-position="left"
                              data-tooltip="Optional"
                              style={{ fontSize: "18px" }}
                            >
                              info_outline
                            </i>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <b>Preis / mtl.</b>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div className="col s3">
                    <div className="card hoverable blue lighten-1">
                      <div className="card-content black-text">
                        <table className="centered">
                          <thead>
                            <tr>
                              <th style={{ fontSize: "18px", color: "black" }}>
                                Essential
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>1</td>
                            </tr>
                            <tr>
                              <td>50 GB</td>
                            </tr>
                            <tr>
                              <td>5 SSD</td>
                            </tr>
                            <tr>
                              <td>10</td>
                            </tr>
                            <tr>
                              <td className="check">
                                <i className="material-icons">check_circle</i>
                              </td>
                            </tr>
                            <tr>
                              <td className="check">
                                <i className="material-icons">check_circle</i>
                              </td>
                            </tr>
                            <tr>
                              <td>89,– € *</td>
                            </tr>
                            <tr>
                              <td>49,– € *</td>
                            </tr>
                            <tr>
                              <td>
                                <b>4,– €</b>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                  <div className="col s3">
                    <div className="card hoverable orange darken-1">
                      <div className="card-content black-text">
                        <table className="centered">
                          <thead>
                            <tr>
                              <th style={{ fontSize: "18px", color: "black" }}>
                                Business
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>1</td>
                            </tr>
                            <tr>
                              <td>50 GB</td>
                            </tr>
                            <tr>
                              <td>5 SSD</td>
                            </tr>
                            <tr>
                              <td>10</td>
                            </tr>
                            <tr>
                              <td className="check">
                                <i className="material-icons">check_circle</i>
                              </td>
                            </tr>
                            <tr>
                              <td className="check">
                                <i className="material-icons">check_circle</i>
                              </td>
                            </tr>
                            <tr>
                              <td>89,– € *</td>
                            </tr>
                            <tr>
                              <td>49,– € *</td>
                            </tr>
                            <tr>
                              <td>
                                <b>4,– €</b>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                  <div className="col s3">
                    <div className="card hoverable orange darken-4">
                      <div className="card-content black-text">
                        <table className="centered">
                          <thead>
                            <tr>
                              <th style={{ fontSize: "18px", color: "black" }}>
                                Pro
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>1</td>
                            </tr>
                            <tr>
                              <td>50 GB</td>
                            </tr>
                            <tr>
                              <td>5 SSD</td>
                            </tr>
                            <tr>
                              <td>10</td>
                            </tr>
                            <tr>
                              <td className="check">
                                <i className="material-icons">check_circle</i>
                              </td>
                            </tr>
                            <tr>
                              <td className="check">
                                <i className="material-icons">check_circle</i>
                              </td>
                            </tr>
                            <tr>
                              <td>89,– € *</td>
                            </tr>
                            <tr>
                              <td>49,– € *</td>
                            </tr>
                            <tr>
                              <td>
                                <b>4,– €</b>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div id="premium">
                <div className="row">
                  <div className="col s3">
                    <table style={{ marginTop: "32px" }}>
                      <thead>
                        <tr>
                          <th style={{ fontSize: "18px" }}>Paket</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>Seiten</td>
                        </tr>
                        <tr>
                          <td>
                            <span>Designentwurf</span>
                          </td>
                        </tr>
                        <tr>
                          <td>HTML5 Template</td>
                        </tr>
                        <tr>
                          <td>Datenschutz</td>
                        </tr>
                        <tr>
                          <td>
                            Responsive{" "}
                            <i
                              className="tooltipped material-icons right"
                              data-position="right"
                              data-tooltip="Responsive für Endgeräte, vor allem Smartphones und Tablets"
                              style={{ fontSize: "18px" }}
                            >
                              info_outline
                            </i>
                          </td>
                        </tr>
                        <tr>
                          <td>Social Media Links</td>
                        </tr>
                        <tr>
                          <td>Kontaktformular</td>
                        </tr>
                        <tr>
                          <td>Location Karte</td>
                        </tr>
                        <tr>
                          <td>SEO</td>
                        </tr>
                        <tr>
                          <td>Google Analytics</td>
                        </tr>
                        <tr>
                          <td>Tag Manager</td>
                        </tr>
                        <tr>
                          <td>Google Optimize</td>
                        </tr>
                        <tr>
                          <td>Multilingual</td>
                        </tr>
                        <tr>
                          <td>
                            <b>Preis</b>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div className="col s3">
                    <div className="card hoverable blue lighten-1">
                      <div className="card-content black-text">
                        <table className="centered">
                          <thead>
                            <tr>
                              <th style={{ fontSize: "18px", color: "black" }}>
                                Pro + 3
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>9</td>
                            </tr>
                            <tr>
                              <td className="check">
                                <i className="material-icons">check_circle</i>
                              </td>
                            </tr>
                            <tr>
                              <td className="check">
                                <i className="material-icons">check_circle</i>
                              </td>
                            </tr>
                            <tr>
                              <td className="check">
                                <i className="material-icons">check_circle</i>
                              </td>
                            </tr>
                            <tr>
                              <td>+ 1.299,– € *</td>
                            </tr>
                            <tr>
                              <td>-</td>
                            </tr>
                            <tr>
                              <td>-</td>
                            </tr>
                            <tr>
                              <td>-</td>
                            </tr>
                            <tr>
                              <td>-</td>
                            </tr>
                            <tr>
                              <td>-</td>
                            </tr>
                            <tr>
                              <td>-</td>
                            </tr>
                            <tr>
                              <td>-</td>
                            </tr>
                            <tr>
                              <td>-</td>
                            </tr>
                            <tr>
                              <td>
                                <b>4.289,– € *</b>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                  <div className="col s3">
                    <div className="card hoverable orange darken-1">
                      <div className="card-content black-text">
                        <table className="centered">
                          <thead>
                            <tr>
                              <th style={{ fontSize: "18px", color: "black" }}>
                                Pro + 6
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>12</td>
                            </tr>
                            <tr>
                              <td className="check">
                                <i className="material-icons">check_circle</i>
                              </td>
                            </tr>
                            <tr>
                              <td className="check">
                                <i className="material-icons">check_circle</i>
                              </td>
                            </tr>
                            <tr>
                              <td className="check">
                                <i className="material-icons">check_circle</i>
                              </td>
                            </tr>
                            <tr>
                              <td>+ 1.779,– € *</td>
                            </tr>
                            <tr>
                              <td>-</td>
                            </tr>
                            <tr>
                              <td>-</td>
                            </tr>
                            <tr>
                              <td>-</td>
                            </tr>
                            <tr>
                              <td>-</td>
                            </tr>
                            <tr>
                              <td>-</td>
                            </tr>
                            <tr>
                              <td>-</td>
                            </tr>
                            <tr>
                              <td>-</td>
                            </tr>
                            <tr>
                              <td>-</td>
                            </tr>
                            <tr>
                              <td>
                                <b>5.750,– € *</b>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                  <div className="col s3">
                    <div className="card hoverable orange darken-4">
                      <div className="card-content black-text">
                        <table className="centered">
                          <thead>
                            <tr>
                              <th style={{ fontSize: "18px", color: "black" }}>
                                Pro + 12
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>18</td>
                            </tr>
                            <tr>
                              <td className="check">
                                <i className="material-icons">check_circle</i>
                              </td>
                            </tr>
                            <tr>
                              <td className="check">
                                <i className="material-icons">check_circle</i>
                              </td>
                            </tr>
                            <tr>
                              <td className="check">
                                <i className="material-icons">check_circle</i>
                              </td>
                            </tr>
                            <tr>
                              <td>+ 2.579,– € *</td>
                            </tr>
                            <tr>
                              <td className="check">
                                <i className="material-icons">check_circle</i>
                              </td>
                            </tr>
                            <tr>
                              <td className="check">
                                <i className="material-icons">check_circle</i>
                              </td>
                            </tr>
                            <tr>
                              <td>-</td>
                            </tr>
                            <tr>
                              <td>-</td>
                            </tr>
                            <tr>
                              <td>-</td>
                            </tr>
                            <tr>
                              <td>-</td>
                            </tr>
                            <tr>
                              <td>-</td>
                            </tr>
                            <tr>
                              <td>-</td>
                            </tr>
                            <tr>
                              <td>
                                <b>8.589,– € *</b>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col s3">
                    <table style={{ marginTop: "32px" }}>
                      <thead>
                        <tr>
                          <th style={{ fontSize: "18px" }}>Webhosting</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>
                            Domäne inklusive{" "}
                            <i
                              className="tooltipped material-icons right"
                              data-position="left"
                              data-tooltip="Sie bekommen eine kostenlose Domäne: .de, .eu, .com, .net, .org, .info, .me, .biz, .online"
                              style={{ fontSize: "18px" }}
                            >
                              info_outline
                            </i>
                          </td>
                        </tr>
                        <tr>
                          <td>Webspace</td>
                        </tr>
                        <tr>
                          <td>
                            Datenbanken
                            <i
                              className="tooltipped material-icons right"
                              data-position="left"
                              data-tooltip="Je Datenbank 1 GB"
                              style={{ fontSize: "18px" }}
                            >
                              info_outline
                            </i>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            E-Mail-Postfächer
                            <i
                              className="tooltipped material-icons right"
                              data-position="left"
                              data-tooltip="Je Postfach 2 GB (für ca. 10.000 Emails) jederzeit erweiterbar"
                              style={{ fontSize: "18px" }}
                            >
                              info_outline
                            </i>
                          </td>
                        </tr>
                        <tr>
                          <td>Spam-Filter</td>
                        </tr>
                        <tr>
                          <td>SSL</td>
                        </tr>
                        <tr>
                          <td>Einrichtungsgebühr</td>
                        </tr>
                        <tr>
                          <td>
                            Wartungsservice / mtl.
                            <i
                              className="tooltipped material-icons right"
                              data-position="left"
                              data-tooltip="Optional"
                              style={{ fontSize: "18px" }}
                            >
                              info_outline
                            </i>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <b>Preis / mtl.</b>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div className="col s3">
                    <div className="card hoverable blue lighten-1">
                      <div className="card-content black-text">
                        <table className="centered">
                          <thead>
                            <tr>
                              <th style={{ fontSize: "18px", color: "black" }}>
                                Pro + 3
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>1</td>
                            </tr>
                            <tr>
                              <td>50 GB</td>
                            </tr>
                            <tr>
                              <td>5 SSD</td>
                            </tr>
                            <tr>
                              <td>10</td>
                            </tr>
                            <tr>
                              <td className="check">
                                <i className="material-icons">check_circle</i>
                              </td>
                            </tr>
                            <tr>
                              <td className="check">
                                <i className="material-icons">check_circle</i>
                              </td>
                            </tr>
                            <tr>
                              <td>89,– € *</td>
                            </tr>
                            <tr>
                              <td>49,– € *</td>
                            </tr>
                            <tr>
                              <td>
                                <b>4,– €</b>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                  <div className="col s3">
                    <div className="card hoverable orange darken-1">
                      <div className="card-content black-text">
                        <table className="centered">
                          <thead>
                            <tr>
                              <th style={{ fontSize: "18px", color: "black" }}>
                                Pro + 6
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>1</td>
                            </tr>
                            <tr>
                              <td>50 GB</td>
                            </tr>
                            <tr>
                              <td>5 SSD</td>
                            </tr>
                            <tr>
                              <td>10</td>
                            </tr>
                            <tr>
                              <td className="check">
                                <i className="material-icons">check_circle</i>
                              </td>
                            </tr>
                            <tr>
                              <td className="check">
                                <i className="material-icons">check_circle</i>
                              </td>
                            </tr>
                            <tr>
                              <td>89,– € *</td>
                            </tr>
                            <tr>
                              <td>49,– € *</td>
                            </tr>
                            <tr>
                              <td>
                                <b>4,– €</b>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                  <div className="col s3">
                    <div className="card hoverable orange darken-4">
                      <div className="card-content black-text">
                        <table className="centered">
                          <thead>
                            <tr>
                              <th style={{ fontSize: "18px", color: "black" }}>
                                Pro + 12
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>1</td>
                            </tr>
                            <tr>
                              <td>50 GB</td>
                            </tr>
                            <tr>
                              <td>5 SSD</td>
                            </tr>
                            <tr>
                              <td>10</td>
                            </tr>
                            <tr>
                              <td className="check">
                                <i className="material-icons">check_circle</i>
                              </td>
                            </tr>
                            <tr>
                              <td className="check">
                                <i className="material-icons">check_circle</i>
                              </td>
                            </tr>
                            <tr>
                              <td>89,– € *</td>
                            </tr>
                            <tr>
                              <td>49,– € *</td>
                            </tr>
                            <tr>
                              <td>
                                <b>4,– €</b>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div id="cms">
                <div className="row">
                  <div className="col s3">
                    <table style={{ marginTop: "32px" }}>
                      <thead>
                        <tr>
                          <th style={{ fontSize: "18px" }}>Paket</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>Seiten</td>
                        </tr>
                        <tr>
                          <td>
                            <span>Designentwurf</span>
                          </td>
                        </tr>
                        <tr>
                          <td>HTML5 Template</td>
                        </tr>
                        <tr>
                          <td>Datenschutz</td>
                        </tr>
                        <tr>
                          <td>
                            Responsive{" "}
                            <i
                              className="tooltipped material-icons right"
                              data-position="right"
                              data-tooltip="Responsive für Endgeräte, vor allem Smartphones und Tablets"
                              style={{ fontSize: "18px" }}
                            >
                              info_outline
                            </i>
                          </td>
                        </tr>
                        <tr>
                          <td>Social Media Links</td>
                        </tr>
                        <tr>
                          <td>Kontaktformular</td>
                        </tr>
                        <tr>
                          <td>Location Karte</td>
                        </tr>
                        <tr>
                          <td>SEO</td>
                        </tr>
                        <tr>
                          <td>Google Analytics</td>
                        </tr>
                        <tr>
                          <td>Tag Manager</td>
                        </tr>
                        <tr>
                          <td>Google Optimize</td>
                        </tr>
                        <tr>
                          <td>Multilingual</td>
                        </tr>
                        <tr>
                          <td>
                            <b>Preis</b>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div className="col s3">
                    <div className="card hoverable blue lighten-1">
                      <div className="card-content black-text">
                        <table className="centered">
                          <thead>
                            <tr>
                              <th style={{ fontSize: "18px", color: "black" }}>
                                Essential
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>9</td>
                            </tr>
                            <tr>
                              <td className="check">
                                <i className="material-icons">check_circle</i>
                              </td>
                            </tr>
                            <tr>
                              <td className="check">
                                <i className="material-icons">check_circle</i>
                              </td>
                            </tr>
                            <tr>
                              <td className="check">
                                <i className="material-icons">check_circle</i>
                              </td>
                            </tr>
                            <tr>
                              <td>+ 1.299,– € *</td>
                            </tr>
                            <tr>
                              <td>-</td>
                            </tr>
                            <tr>
                              <td>-</td>
                            </tr>
                            <tr>
                              <td>-</td>
                            </tr>
                            <tr>
                              <td>-</td>
                            </tr>
                            <tr>
                              <td>-</td>
                            </tr>
                            <tr>
                              <td>-</td>
                            </tr>
                            <tr>
                              <td>-</td>
                            </tr>
                            <tr>
                              <td>-</td>
                            </tr>
                            <tr>
                              <td>
                                <b>6.388,– € *</b>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                  <div className="col s3">
                    <div className="card hoverable orange darken-1">
                      <div className="card-content black-text">
                        <table className="centered">
                          <thead>
                            <tr>
                              <th style={{ fontSize: "18px", color: "black" }}>
                                Business
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>12</td>
                            </tr>
                            <tr>
                              <td className="check">
                                <i className="material-icons">check_circle</i>
                              </td>
                            </tr>
                            <tr>
                              <td className="check">
                                <i className="material-icons">check_circle</i>
                              </td>
                            </tr>
                            <tr>
                              <td className="check">
                                <i className="material-icons">check_circle</i>
                              </td>
                            </tr>
                            <tr>
                              <td>+ 1.779,– € *</td>
                            </tr>
                            <tr>
                              <td>-</td>
                            </tr>
                            <tr>
                              <td>-</td>
                            </tr>
                            <tr>
                              <td>-</td>
                            </tr>
                            <tr>
                              <td>-</td>
                            </tr>
                            <tr>
                              <td>-</td>
                            </tr>
                            <tr>
                              <td>-</td>
                            </tr>
                            <tr>
                              <td>-</td>
                            </tr>
                            <tr>
                              <td>-</td>
                            </tr>
                            <tr>
                              <td>
                                <b>7.849,– € *</b>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                  <div className="col s3">
                    <div className="card hoverable orange darken-4">
                      <div className="card-content black-text">
                        <table className="centered">
                          <thead>
                            <tr>
                              <th style={{ fontSize: "18px", color: "black" }}>
                                Pro
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>18</td>
                            </tr>
                            <tr>
                              <td className="check">
                                <i className="material-icons">check_circle</i>
                              </td>
                            </tr>
                            <tr>
                              <td className="check">
                                <i className="material-icons">check_circle</i>
                              </td>
                            </tr>
                            <tr>
                              <td className="check">
                                <i className="material-icons">check_circle</i>
                              </td>
                            </tr>
                            <tr>
                              <td>+ 2.579,– € *</td>
                            </tr>
                            <tr>
                              <td className="check">
                                <i className="material-icons">check_circle</i>
                              </td>
                            </tr>
                            <tr>
                              <td className="check">
                                <i className="material-icons">check_circle</i>
                              </td>
                            </tr>
                            <tr>
                              <td>-</td>
                            </tr>
                            <tr>
                              <td>-</td>
                            </tr>
                            <tr>
                              <td>-</td>
                            </tr>
                            <tr>
                              <td>-</td>
                            </tr>
                            <tr>
                              <td>-</td>
                            </tr>
                            <tr>
                              <td>-</td>
                            </tr>
                            <tr>
                              <td>
                                <b>10.688,– € *</b>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div id="cmsPremium">
                <div className="row">
                  <div className="col s3">
                    <table style={{ marginTop: "32px" }}>
                      <thead>
                        <tr>
                          <th style={{ fontSize: "18px" }}>Paket</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>Seiten</td>
                        </tr>
                        <tr>
                          <td>
                            <span>Designentwurf</span>
                          </td>
                        </tr>
                        <tr>
                          <td>HTML5 Template</td>
                        </tr>
                        <tr>
                          <td>Datenschutz</td>
                        </tr>
                        <tr>
                          <td>
                            Responsive{" "}
                            <i
                              className="tooltipped material-icons right"
                              data-position="right"
                              data-tooltip="Responsive für Endgeräte, vor allem Smartphones und Tablets"
                              style={{ fontSize: "18px" }}
                            >
                              info_outline
                            </i>
                          </td>
                        </tr>
                        <tr>
                          <td>Social Media Links</td>
                        </tr>
                        <tr>
                          <td>Kontaktformular</td>
                        </tr>
                        <tr>
                          <td>Location Karte</td>
                        </tr>
                        <tr>
                          <td>SEO</td>
                        </tr>
                        <tr>
                          <td>Google Analytics</td>
                        </tr>
                        <tr>
                          <td>Tag Manager</td>
                        </tr>
                        <tr>
                          <td>Google Optimize</td>
                        </tr>
                        <tr>
                          <td>Multilingual</td>
                        </tr>
                        <tr>
                          <td>
                            <b>Preis</b>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div className="col s3">
                    <div className="card hoverable blue lighten-1">
                      <div className="card-content black-text">
                        <table className="centered">
                          <thead>
                            <tr>
                              <th style={{ fontSize: "18px", color: "black" }}>
                                CMS + 6
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>24</td>
                            </tr>
                            <tr>
                              <td className="check">
                                <i className="material-icons">check_circle</i>
                              </td>
                            </tr>
                            <tr>
                              <td className="check">
                                <i className="material-icons">check_circle</i>
                              </td>
                            </tr>
                            <tr>
                              <td className="check">
                                <i className="material-icons">check_circle</i>
                              </td>
                            </tr>
                            <tr>
                              <td>+ 3.475,– € *</td>
                            </tr>
                            <tr>
                              <td>-</td>
                            </tr>
                            <tr>
                              <td>-</td>
                            </tr>
                            <tr>
                              <td>-</td>
                            </tr>
                            <tr>
                              <td>-</td>
                            </tr>
                            <tr>
                              <td>-</td>
                            </tr>
                            <tr>
                              <td>-</td>
                            </tr>
                            <tr>
                              <td>-</td>
                            </tr>
                            <tr>
                              <td>-</td>
                            </tr>
                            <tr>
                              <td>
                                <b>14.369,– € *</b>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                  <div className="col s3">
                    <div className="card hoverable orange darken-1">
                      <div className="card-content black-text">
                        <table className="centered">
                          <thead>
                            <tr>
                              <th style={{ fontSize: "18px", color: "black" }}>
                                CMS + 12
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>30</td>
                            </tr>
                            <tr>
                              <td className="check">
                                <i className="material-icons">check_circle</i>
                              </td>
                            </tr>
                            <tr>
                              <td className="check">
                                <i className="material-icons">check_circle</i>
                              </td>
                            </tr>
                            <tr>
                              <td className="check">
                                <i className="material-icons">check_circle</i>
                              </td>
                            </tr>
                            <tr>
                              <td>+ 5.254,– € *</td>
                            </tr>
                            <tr>
                              <td>-</td>
                            </tr>
                            <tr>
                              <td>-</td>
                            </tr>
                            <tr>
                              <td>-</td>
                            </tr>
                            <tr>
                              <td>-</td>
                            </tr>
                            <tr>
                              <td>-</td>
                            </tr>
                            <tr>
                              <td>-</td>
                            </tr>
                            <tr>
                              <td>-</td>
                            </tr>
                            <tr>
                              <td>-</td>
                            </tr>
                            <tr>
                              <td>
                                <b>17.789,– € *</b>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                  <div className="col s3">
                    <div className="card hoverable orange darken-4">
                      <div className="card-content black-text">
                        <table className="centered">
                          <thead>
                            <tr>
                              <th style={{ fontSize: "18px", color: "black" }}>
                                CMS + 18
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>36</td>
                            </tr>
                            <tr>
                              <td className="check">
                                <i className="material-icons">check_circle</i>
                              </td>
                            </tr>
                            <tr>
                              <td className="check">
                                <i className="material-icons">check_circle</i>
                              </td>
                            </tr>
                            <tr>
                              <td className="check">
                                <i className="material-icons">check_circle</i>
                              </td>
                            </tr>
                            <tr>
                              <td>+ 6.889,– € *</td>
                            </tr>
                            <tr>
                              <td className="check">
                                <i className="material-icons">check_circle</i>
                              </td>
                            </tr>
                            <tr>
                              <td className="check">
                                <i className="material-icons">check_circle</i>
                              </td>
                            </tr>
                            <tr>
                              <td>-</td>
                            </tr>
                            <tr>
                              <td>-</td>
                            </tr>
                            <tr>
                              <td>-</td>
                            </tr>
                            <tr>
                              <td>-</td>
                            </tr>
                            <tr>
                              <td>-</td>
                            </tr>
                            <tr>
                              <td>-</td>
                            </tr>
                            <tr>
                              <td>
                                <b>21.759,– € *</b>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
          <div className="section">
            <div className="row">
              <div className="col s12 m12">
                <span>* Alle Preise zzgl. MwSt.</span>
              </div>
            </div>
          </div>
          {isMobile ? (
            <div className="section">
              <div className="row center">
                <div className="col s12 m12">
                  <a
                    style={{ width: "100%" }}
                    href="/insights"
                    className="btn-large orange darken-4"
                  >
                    Beispiele ansehen
                    <i
                      className="material-icons right"
                      style={{ fontSize: "20px" }}
                    >
                      arrow_forward
                    </i>
                  </a>
                </div>
              </div>
              <div className="row center">
                <div className="col s12 m12">
                  <a
                    style={{ width: "100%" }}
                    href="/kontakt"
                    className="btn-large orange darken-4"
                  >
                    Jetzt beraten lassen
                    <i
                      className="material-icons right"
                      style={{ fontSize: "20px" }}
                    >
                      arrow_forward
                    </i>
                  </a>
                </div>
              </div>
            </div>
          ) : (
            <div className="section">
              <div className="row center">
                <div className="col s12 m6">
                  <a
                    style={{ width: "100%" }}
                    href="/insights"
                    className="btn-large orange darken-4"
                  >
                    Beispiele ansehen
                    <i
                      className="material-icons right"
                      style={{ fontSize: "20px" }}
                    >
                      arrow_forward
                    </i>
                  </a>
                </div>
                <div className="col s12 m6">
                  <a
                    style={{ width: "100%" }}
                    href="/kontakt"
                    className="btn-large orange darken-4"
                  >
                    Jetzt beraten lassen
                    <i
                      className="material-icons right"
                      style={{ fontSize: "20px" }}
                    >
                      arrow_forward
                    </i>
                  </a>
                </div>
              </div>
            </div>
          )}
        </div>
      </React.Fragment>
    );
  }
}

export default Websites;



// WEBPACK FOOTER //
// ./src/components/layout/pages/Websites.js